import { APP_INITIALIZER, Provider } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DeviceInfoInterceptor } from './device-info.interceptor';
import { DeviceTrackingService } from '../shared/services/device-tracking.service';

/**
 * Starts device registration at app start without holding the app up: the returned function
 * returns nothing, so bootstrap does not wait for it. A throw from an app initializer would abort
 * bootstrap, hence the catch.
 * @param deviceTracking the service to start
 * @returns the app initializer
 */
export function startDeviceTracking(deviceTracking: DeviceTrackingService): () => void {
  return () => {
    try {
      deviceTracking.start();
    } catch (error) {
      console.error('Device tracking could not start:', error);
    }
  };
}

/**
 * Request-log device tracking: the register call at app start and the device headers on API
 * requests. Both are no-ops unless `environment.DEVICE_TRACKING_ENABLED` is true.
 * @returns the providers to add to the application config
 */
export function provideDeviceTracking(): Provider[] {
  return [
    { provide: HTTP_INTERCEPTORS, useClass: DeviceInfoInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: startDeviceTracking, deps: [DeviceTrackingService], multi: true },
  ];
}
